import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

import { Label } from 'sdc-i18n-react';
import { labelsStore } from 'sdc-i18n-stores';

import Select from 'react-select';

import { MarkdownPanel } from 'sdc-markdown-viewer';
import { editingMode } from 'sdc-cms-writing';
import { fieldValue } from 'sdc-data-models';

export var EntryChoices = inject('typesStore')(observer(function (_ref) {
  var typesStore = _ref.typesStore,
      field = _ref.field,
      store = _ref.store,
      label = _ref.label;

  if (field.dataType !== 'select') return null;

  var defaultLabel = function defaultLabel(s) {
    return React.createElement(Label, { value: typesStore.typesByID[field.typeID].name.toLowerCase() + '.' + field.key + '.' + s });
  };

  var labelFor = function labelFor(s) {
    return typeof label === 'function' ? label(s) : defaultLabel(s);
  };

  var toOption = function toOption(s) {
    return {
      value: s,
      label: labelFor(s)
    };
  };

  var current = fieldValue(store.selected, field.key);
  var options = field.choices.split(',').map(toOption);

  if (editingMode.isViewMode.get()) {
    return typeof label === 'function' ? React.createElement(
      'span',
      null,
      label(current)
    ) : React.createElement(MarkdownPanel, { text: labelsStore.labelFor(typesStore.typesByID[field.typeID].name.toLowerCase() + '.' + field.key + '.' + current) });
  } else {
    return React.createElement(Select, {
      clearable: true,
      menuPortalTarget: document.body,
      value: toJS(toOption(current)),
      isMulti: field.multiple,
      options: options,
      onChange: store.updateChoice(field) });
  }
}));